export default __webpack_public_path__ + "static/media/united-states-of-america.923a5cc9.svg";